import SvgBabLogo from 'jsx:./assets/babLogo.svg';
import SvgLogo from 'jsx:./assets/logo.svg';
import SvgLogoEn from 'jsx:./assets/logoEn.svg';
import SvgLogoFr from 'jsx:./assets/logoFr.svg';
import SvgLogoHalloween from 'jsx:./assets/logoHalloween.svg';
import SvgLogoHalloweenEn from 'jsx:./assets/logoHalloweenEn.svg';
import SvgLogoHalloweenFr from 'jsx:./assets/logoHalloweenFr.svg';
import React from 'react';

const DefaultLogos = {
  _bab: SvgBabLogo,
  _default: SvgLogo,
  en: SvgLogoEn,
  fr: SvgLogoFr,
};

const HalloweenLogos = {
  ...DefaultLogos,
  _default: SvgLogoHalloween,
  en: SvgLogoHalloweenEn,
  fr: SvgLogoHalloweenFr,
};

const Logo = ({ language = null, bab = false, ...props }) => {
  let Logos = DefaultLogos;

  // Halloween
  if ((new Date().getDate() >= 15 && new Date().getMonth() === 9) ||
    (new Date().getDate() <= 2 && new Date().getMonth() === 10)) {
    Logos = HalloweenLogos;
  }

  const Svg = (bab ? Logos._bab : Logos[language]) || Logos._default;
  return <Svg {...props} />;
};

export default React.memo(Logo);
